// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullheight {
  min-height: 100vh;
}

.settings-cog-btn {
  font-size: 20px !important;
}

.hide-popup {
  pointer-events: none;
}

.show-popup {
  cursor: pointer;
}

.snapshot-icons {
  display: inline-block;
}

.materialsContainer {
  overflow: hidden;
  height: 100%;
}

.project-link {
  color: #003DA5;
  cursor: pointer;
}
.project-link:hover {
  text-decoration: underline;
}

.font-bold {
  font-weight: 700;
}

.footerIcons {
  display: flex;
  border-top: 1px solid black;
}

.recordfooter {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
}

.footerIcon {
  display: flex;
  flex-direction: row;
}

.footIcon {
  border-left: 1px solid;
  padding-left: 4px;
}

.footerIconAll {
  font-size: 16px;
}

.footerIconsMain {
  display: flex;
  align-items: center;
}

.footerIcons2 {
  color: #ff0000;
  rotate: 180deg;
}

.footerIcons3 {
  color: #01ff1a;
}

.footerIcons4 {
  color: #ff0000;
  margin-right: 10px;
}

.footerIcons5 {
  color: #01ff1a;
}

.footerIcons6 {
  color: red;
}

.footerIcons7 {
  color: gray;
}

.footerIcons8 {
  color: #01ff1a;
}

.footerIcons9 {
  color: #ff0000;
}

.footerIcons10 {
  font-weight: bold;
  color: black;
}

.footerIcons11 {
  font-weight: bold;
  color: black;
}

.footerIconsContent1 {
  font-weight: 500;
  line-height: 12.19px;
  padding: 0 5px;
  margin: 0px 4px 0px 4px;
  font-size: 8px;
  color: black;
}

.pi pi-circle-off {
  font-size: 16px;
  margin-top: 10px;
}

.col-header {
  text-align: center !important;
  color: #003da5 !important;
  background: #edf4fa !important;
}

.header-and-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.materialsContainer {
  overflow: hidden;
  height: 100%;
}
.materialsContainer .flex-display {
  display: flex;
}
.materialsContainer tr {
  height: 36px !important;
}
.materialsContainer td,
.materialsContainer th {
  min-width: 140px;
  max-width: 200px;
}
.materialsContainer .p-paginator {
  position: fixed;
  bottom: 1%;
  right: 1%;
  border: 0;
  border-radius: 10px;
  z-index: 100;
  background: transparent;
}
.materialsContainer .cic-tooltip-target {
  display: flex;
  justify-content: center;
}
.materialsContainer table thead th {
  background-color: #edf4fa !important;
  height: 30px;
  border-width: 1px 2px 3px 4px;
  padding: 0 !important;
  word-wrap: initial;
}
.materialsContainer table thead th:nth-child(1) {
  border-left: none !important;
}
.materialsContainer table thead th:last-child {
  border-left: none !important;
}
.materialsContainer table thead th.p-filter-column .p-column-filter .p-fluid {
  min-width: 100px;
  border-radius: 140px;
  background-color: #ffffff !important;
}
.materialsContainer table thead .p-filter-column {
  background-color: #ffffff !important;
  padding: 10px !important;
}
.materialsContainer table .p-datatable .p-datatable-tbody > tr {
  line-height: 50px !important;
  font-size: 12px;
}
.materialsContainer table td,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td {
  border-bottom: 0.5px solid #acacac !important;
  font-size: 12px;
  color: #595959;
  background: #ffffff !important;
  padding: 0 7px !important;
}
.materialsContainer table td:first-child,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td:first-child {
  border-left: none !important;
}
.materialsContainer table td:last-child,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-right: none !important;
}
.materialsContainer table td .active-status,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td .active-status {
  background-color: #dfebff;
  color: #003da5;
}
.materialsContainer table td .not-started-status,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td .not-started-status {
  background-color: #f1f1f1;
  color: #595959;
}
.materialsContainer table td .completed-status,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td .completed-status {
  background-color: #e6ffe8;
  color: #006f05;
}
.materialsContainer table .p-inputtext {
  border-radius: 50px;
}
.materialsContainer .actions {
  padding-left: 20px;
}
.materialsContainer .p-datatable .p-datatable-footer {
  background: white;
  border: 0;
  border-width: 0;
  padding: 1rem 1rem;
  font-weight: 300;
  padding: 0;
}
.materialsContainer .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  height: calc(100vh - 230px) !important;
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .materialsContainer .p-datatable > .p-datatable-wrapper {
    height: calc(100% - 200px);
  }
}
.materialsContainer .p-paginator {
  margin-right: 20px;
}
.materialsContainer #special-project > .p-datatable-wrapper {
  overflow: auto;
  height: calc(100% - 100px);
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .materialsContainer #special-project > .p-datatable-wrapper {
    height: calc(100% - 200px);
  }
}
.materialsContainer .p-datatable-scrollable-body {
  overflow: auto;
}
.materialsContainer .p-datatable-table {
  line-height: 12px;
  width: 122%;
}
.materialsContainer .p-column-title {
  font-weight: 400;
}
.materialsContainer .p-column-title span {
  font-size: 12px;
  margin-left: 2px;
  align-items: center;
}
.materialsContainer .p-datatable-tbody {
  font-weight: 400;
}
.materialsContainer td,
.materialsContainer table .p-datatable .p-datatable-tbody > tr > td,
.materialsContainer th,
.materialsContainer tr {
  position: relative;
}
.materialsContainer.dsbp-wrapper .p-datatable {
  height: calc(100% - 220px);
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Tabs/MaterialsTab/MaterialsTab.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;AAFF;;AAMA;EACE,0BAAA;AAHF;;AAOA;EACE,oBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAUA;EACE,gBAAA;EACA,YAAA;AAPF;;AAWA;EACE,cAAA;EACA,eAAA;AARF;AAUE;EACE,0BAAA;AARJ;;AAaA;EACE,gBAAA;AAVF;;AAcA;EACE,aAAA;EACA,2BAAA;AAXF;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAbF;;AAiBA;EACE,aAAA;EACA,mBAAA;AAdF;;AAkBA;EACE,sBAAA;EACA,iBAAA;AAfF;;AAmBA;EACE,eAAA;AAhBF;;AAoBA;EACE,aAAA;EACA,mBAAA;AAjBF;;AAqBA;EACE,cAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,UAAA;AAlBF;;AAqBA;EACE,WAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;AAlBF;;AAsBA;EACE,6BAAA;EACA,yBAAA;EACA,8BAAA;AAnBF;;AAuBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,YAAA;AApBF;AAsBE;EACE,aAAA;AApBJ;AAuBE;EACE,uBAAA;AArBJ;AAwBE;;EAEE,gBAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,uBAAA;AAxBJ;AA6BM;EACE,oCAAA;EACA,YAAA;EACA,6BAAA;EAEA,qBAAA;EACA,kBAAA;AA5BR;AA8BQ;EACE,4BAAA;AA5BV;AA+BQ;EACE,4BAAA;AA7BV;AAiCM;EACE,gBAAA;EACA,oBAAA;EACA,oCAAA;AA/BR;AAkCM;EACE,oCAAA;EACA,wBAAA;AAhCR;AAwCI;EACE,4BAAA;EACA,eAAA;AAtCN;AAyCI;;EAEE,6CAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;EACA,yBAAA;AAvCN;AA0CM;;EACE,4BAAA;AAvCR;AA0CM;;EACE,6BAAA;AAvCR;AA0CM;;EACE,yBAAA;EACA,cAAA;AAvCR;AA0CM;;EACE,yBAAA;EACA,cAAA;AAvCR;AA0CM;;EACE,yBAAA;EACA,cAAA;AAvCR;AA2CI;EACE,mBAAA;AAzCN;AA6CE;EACE,kBAAA;AA3CJ;AA8CE;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA5CJ;AA+CE;EACE,cAAA;EACA,sCAAA;EACA,WAAA;AA7CJ;AA+CI;EALF;IAMI,0BAAA;EA5CJ;AACF;AA8CE;EACE,kBAAA;AA5CJ;AAgDE;EACE,cAAA;EACA,0BAAA;EACA,WAAA;AA9CJ;AAgDI;EALF;IAMI,0BAAA;EA7CJ;AACF;AAgDE;EACE,cAAA;AA9CJ;AAiDE;EACE,iBAAA;EACA,WAAA;AA/CJ;AAkDE;EACE,gBA9TY;AA8QhB;AAkDI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAhDN;AAoDE;EACE,gBAxUY;AAsRhB;AAqDE;;;;EAIE,kBAAA;AAnDJ;AAuDI;EACE,0BAAA;AArDN","sourcesContent":["$fontWeight400: 400;\n\n// Full height for loading overlay\n.fullheight {\n  min-height: 100vh;\n}\n\n// Settings cog button font size\n.settings-cog-btn {\n  font-size: 20px !important;\n}\n\n// Only keeping classes used in index.js and MaterialsListHeader.js\n.hide-popup {\n  pointer-events: none;\n}\n\n.show-popup {\n  cursor: pointer;\n}\n\n.snapshot-icons {\n  display: inline-block;\n}\n\n// Datepicker for ProjectSetUp component Style End\n// .fullkit-dialog and children not used directly in index.js or MaterialsListHeader.js\n\n.materialsContainer {\n  overflow: hidden;\n  height: 100%;\n}\n\n// Project link styling for AWMProjectID and AWMProjectName\n.project-link {\n  color: #003DA5;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n// Used for frozen columns\n.font-bold {\n  font-weight: 700;\n}\n\n// Used for footer icons in index.js\n.footerIcons {\n  display: flex;\n  border-top: 1px solid black;\n}\n\n// ---- footerIcon Styles start-----//\n// Used for footer\n.recordfooter {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n// Used for footer\n.footerIcon {\n  display: flex;\n  flex-direction: row;\n}\n\n// Used for footer\n.footIcon {\n  border-left: 1px solid;\n  padding-left: 4px;\n}\n\n// Used for footer\n.footerIconAll {\n  font-size: 16px;\n}\n\n// Used for footer\n.footerIconsMain {\n  display: flex;\n  align-items: center;\n}\n\n// Used for footer icon coloring\n.footerIcons2 {\n  color: #ff0000;\n  rotate: 180deg;\n}\n\n.footerIcons3 {\n  color: #01ff1a;\n}\n\n.footerIcons4 {\n  color: #ff0000;\n  margin-right: 10px;\n}\n\n.footerIcons5 {\n  color: #01ff1a;\n}\n\n.footerIcons6 {\n  color: red;\n}\n\n.footerIcons7 {\n  color: gray;\n}\n\n.footerIcons8 {\n  color: #01ff1a;\n}\n\n.footerIcons9 {\n  color: #ff0000;\n}\n\n.footerIcons10 {\n  font-weight: bold;\n  color: black;\n}\n\n.footerIcons11 {\n  font-weight: bold;\n  color: black;\n}\n\n.footerIconsContent1 {\n  font-weight: 500;\n  line-height: 12.19px;\n  padding: 0 5px;\n  margin: 0px 4px 0px 4px;\n  font-size: 8px;\n  color: black;\n}\n\n.pi pi-circle-off {\n  font-size: 16px;\n  margin-top: 10px;\n}\n\n// Used for column header\n.col-header {\n  text-align: center !important;\n  color: #003da5 !important;\n  background: #edf4fa !important;\n}\n\n// Used for header actions\n.header-and-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n}\n\n.materialsContainer {\n  overflow: hidden;\n  height: 100%;\n\n  .flex-display {\n    display: flex;\n  }\n\n  tr {\n    height: 36px !important;\n  }\n\n  td,\n  th {\n    min-width: 140px;\n    max-width: 200px;\n  }\n\n  .p-paginator {\n    position: fixed;\n    bottom: 1%;\n    right: 1%;\n    border: 0;\n    border-radius: 10px;\n    z-index: 100;\n    background: transparent;\n  }\n\n  .cic-tooltip-target {\n    display: flex;\n    justify-content: center;\n  }\n\n  table {\n    thead {\n      th {\n        background-color: #edf4fa !important;\n        height: 30px;\n        border-width: 1px 2px 3px 4px;\n        // border: 0 !important;\n        padding: 0 !important;\n        word-wrap: initial;\n\n        &:nth-child(1) {\n          border-left: none !important;\n        }\n\n        &:last-child {\n          border-left: none !important;\n        }\n      }\n\n      th.p-filter-column .p-column-filter .p-fluid {\n        min-width: 100px;\n        border-radius: 140px;\n        background-color: #ffffff !important;\n      }\n\n      .p-filter-column {\n        background-color: #ffffff !important;\n        padding: 10px !important;\n      }\n    }\n\n    // tr:nth-child(even)>td {\n    //   background: #fafcff !important;\n    // }\n\n    .p-datatable .p-datatable-tbody>tr {\n      line-height: 50px !important;\n      font-size: 12px;\n    }\n\n    td,\n    .p-datatable .p-datatable-tbody>tr>td {\n      border-bottom: 0.5px solid #acacac !important;\n      font-size: 12px;\n      color: #595959;\n      background: #ffffff !important;\n      padding: 0 7px !important;\n      // white-space: inherit !important;\n\n      &:first-child {\n        border-left: none !important;\n      }\n\n      &:last-child {\n        border-right: none !important;\n      }\n\n      .active-status {\n        background-color: #dfebff;\n        color: #003da5;\n      }\n\n      .not-started-status {\n        background-color: #f1f1f1;\n        color: #595959;\n      }\n\n      .completed-status {\n        background-color: #e6ffe8;\n        color: #006f05;\n      }\n    }\n\n    .p-inputtext {\n      border-radius: 50px;\n    }\n  }\n\n  .actions {\n    padding-left: 20px;\n  }\n\n  .p-datatable .p-datatable-footer {\n    background: white;\n    border: 0;\n    border-width: 0;\n    padding: 1rem 1rem;\n    font-weight: 300;\n    padding: 0;\n  }\n\n  .p-datatable>.p-datatable-wrapper {\n    overflow: auto;\n    height: calc(100vh - 230px) !important;\n    width: 100%;\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 200px);\n    }\n  }\n  .p-paginator {\n    margin-right: 20px;\n  }\n\n  //adjust the height after adding the pagination for special project\n  #special-project>.p-datatable-wrapper {\n    overflow: auto;\n    height: calc(100% - 100px);\n    width: 100%;\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 200px);\n    }\n  }\n\n  .p-datatable-scrollable-body {\n    overflow: auto;\n  }\n\n  .p-datatable-table {\n    line-height: 12px;\n    width: 122%;\n  }\n\n  .p-column-title {\n    font-weight: $fontWeight400;\n\n    span {\n      font-size: 12px;\n      margin-left: 2px;\n      align-items: center;\n    }\n  }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  td,\n  table .p-datatable .p-datatable-tbody>tr>td,\n  th,\n  tr {\n    position: relative;\n  }\n\n  &.dsbp-wrapper {\n    .p-datatable {\n      height: calc(100% - 220px);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
